// extracted by mini-css-extract-plugin
module.exports = {"container":"ChangeModalCart_container__3Q9Yc","info":"ChangeModalCart_info__1mP2K"};